var NmaInterventionType, arrayOf, docShape, docTypes, documentId, explanationType, initial, mapOf, nmaQuestionDocShape, optional, shape, string;

arrayOf = require('lib/db_docs/field_types/array_of');

documentId = require('lib/db_docs/field_types/document_id');

docShape = require('lib/db_docs/field_types/doc_shape');

docTypes = require('lib/db_docs/doc_types');

initial = require('lib/db_docs/field_types/type_decorators').initial;

mapOf = require('lib/db_docs/field_types/map_of');

NmaInterventionType = require('lib/db_docs/field_types/nma_intervention_type');

shape = require('lib/db_docs/field_types/shape');

string = require('lib/db_docs/field_types/built_in_types').string;

optional = shape.typeDecorators.optional;

explanationType = shape({
  id: string,
  text: string
});

nmaQuestionDocShape = docShape({
  author: optional(string),
  docType: initial(docTypes.NMA_QUESTION)(string),
  interventions: initial([])(arrayOf(NmaInterventionType)),
  thresholdOptions: optional(string),
  outcomes: initial([])(arrayOf(documentId)),
  population: optional(string),
  question: string,
  setting: optional(string),
  commonComparator: optional(string),
  explanations: optional(mapOf(explanationType))
});

module.exports = nmaQuestionDocShape;
